import { render, staticRenderFns } from "./ExtendOrder.vue?vue&type=template&id=1db2c4e1&"
import script from "./ExtendOrder.vue?vue&type=script&lang=js&"
export * from "./ExtendOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports